import { combineReducers } from 'redux';

import {
  getProjectListRequest,
  getProjectListFail,
  getProjectListSuccess,
  setProjectListDirty,
  clearProjectList,
} from '../actions';
import { ProjectAction, ProjectListState } from '../types';
import { Reducer } from '../../../types';
import { stripItems } from '../../../../utility/store';

type ReducerOf<T extends keyof ProjectListState> = Reducer<ProjectListState, ProjectAction, T>;

const data: ReducerOf<'data'> = (state = null, action) => {
  switch (action.type) {
    case getProjectListRequest.type:
      return state ? stripItems(state) : null;

    case getProjectListSuccess.type:
      return action.payload;

    case clearProjectList.type:
      return null;

    default:
      return state;
  }
};

const loading: ReducerOf<'loading'> = (state = false, action) => {
  switch (action.type) {
    case getProjectListRequest.type:
      return true;

    case getProjectListSuccess.type:
    case getProjectListFail.type:
      return false;

    default:
      return state;
  }
};

const dirty: ReducerOf<'dirty'> = (state = false, action) => {
  switch (action.type) {
    case setProjectListDirty.type:
      return action.payload;

    case getProjectListSuccess.type:
    case getProjectListFail.type:
      return false;

    default:
      return state;
  }
};

const error: ReducerOf<'error'> = (state = false, action) => {
  switch (action.type){
    case getProjectListFail.type:
      return true;

    case getProjectListSuccess.type:
      return false;

    default:
      return state;
  }
};

export default combineReducers<ProjectListState>({
  data,
  loading,
  dirty,
  error,
});
